module.exports = __webpack_public_path__ + "images/application/approval-speedy-638ca739.svg";